export default __webpack_public_path__ + "static/media/aws_gray.ea3451d8.svg";